import React from 'react';
import Card from '../Card';

const SkeletonCard = ({ variant = 'text', count = 1, className = '', title }) => {
    const renderContent = () => {
        switch (variant) {
            case 'metric':
                return (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        {[...Array(count)].map((_, i) => (
                            <div key={i} className="bg-neutral-50 rounded-lg p-5 border border-neutral-200/50">
                                <div className="flex items-start justify-between mb-3">
                                    <div className="w-10 h-10 bg-neutral-200 rounded-lg animate-pulse"></div>
                                    <div className="w-4 h-4 bg-neutral-200 rounded-full animate-pulse"></div>
                                </div>
                                <div className="h-10 w-20 bg-neutral-200 rounded-lg animate-pulse mb-2"></div>
                                <div className="h-4 w-32 bg-neutral-200 rounded-lg animate-pulse mb-3"></div>
                                <div className="h-6 w-24 bg-neutral-200 rounded-full animate-pulse mb-3"></div>
                                <div className="h-3 w-16 bg-neutral-200 rounded-lg animate-pulse mt-auto"></div>
                            </div>
                        ))}
                    </div>
                );

            case 'list':
                return (
                    <div className="space-y-3">
                        {[...Array(count)].map((_, i) => (
                            <div key={i} className="flex items-start gap-3 p-4 bg-neutral-50 rounded-lg border border-neutral-200/50">
                                <div className="w-5 h-5 bg-neutral-200 rounded-full animate-pulse mt-0.5"></div>
                                <div className="flex-1">
                                    <div className="h-4 w-full bg-neutral-200 rounded-lg animate-pulse mb-2"></div>
                                    <div className="h-4 w-2/3 bg-neutral-200 rounded-lg animate-pulse"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                );

            case 'grid':
                return (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {[...Array(count)].map((_, i) => (
                            <div key={i} className="p-4 bg-neutral-50 rounded-lg border border-neutral-200/50">
                                <div className="h-4 w-24 bg-neutral-200 rounded-lg animate-pulse mb-2"></div>
                                <div className="h-5 w-32 bg-neutral-200 rounded-lg animate-pulse"></div>
                            </div>
                        ))}
                    </div>
                );

            case 'text':
            default:
                return (
                    <div className="space-y-3">
                        {[...Array(count)].map((_, i) => (
                            <div key={i} className="h-16 bg-neutral-50 rounded-lg border border-neutral-200/50 p-4">
                                <div className="h-4 w-full bg-neutral-200 rounded-lg animate-pulse mb-2"></div>
                                <div className="h-4 w-3/4 bg-neutral-200 rounded-lg animate-pulse"></div>
                            </div>
                        ))}
                    </div>
                );
        }
    };

    return (
        <Card className={className}>
            <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 bg-neutral-200 rounded-lg animate-pulse"></div>
                <div>
                    <div className="h-6 w-48 bg-neutral-200 rounded-lg animate-pulse mb-2"></div>
                    {title && <div className="h-4 w-32 bg-neutral-100 rounded-lg animate-pulse"></div>}
                </div>
            </div>
            {renderContent()}
        </Card>
    );
};

export default SkeletonCard;
